if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();
				this.form = this.querySelector('.form');
				if (this.variantIdInput) {
					this.variantIdInput.disabled = false;
				}
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector('cart-notification') ||
					document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');
				this.submitButtonText = this.submitButton.querySelector('span');
				this.variantSelect = this.querySelector('variant-selects');
				this.selectedVariantInput = this.querySelector('.variant-id-input');
				this.quantityInput = this.querySelector('quantity-input');
				this.context = this.getAttribute('data-context');
				this.onQuantityUpdate = undefined;

				if (document.querySelector('cart-drawer'))
					this.submitButton.setAttribute('aria-haspopup', 'dialog');

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			connectedCallback() {
				if (this.variantSelect) {
					this.variantSelect.addEventListener('change', () => this.syncVariantState());
					this.syncVariantState();
				}

				if (this.context == 'pdp' || this.context == 'atc-drawer') {
					this.onQuantityUpdate = subscribe(
						PUB_SUB_EVENTS.quantityUpdate,
						(obj) => {
							if (!obj?.quantity) {
								return
							}
							this.quantityInput.updateQuantity(obj.data.quantity);
						}
					).bind(this);
				}
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.syncVariantState();
				const formData = this.context == 'atc-drawer' ? new FormData(document.querySelector('product-form[data-context="pdp"]').form) : new FormData(this.form);
				const variantId = formData.get('id');
				if (!variantId || variantId === 'undefined') {
					this.handleErrorMessage('Please select an available variant.');
					return;
				}

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading__spinner')?.classList.remove('hidden');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message
							});

							this.handleErrorMessage(response.description);
							this.error = true;
							return;

						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						const startMarker = CartPerformance.createStartingMarker(
							'add:wait-for-subscribers'
						);
						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response
							}).then(() => {
								CartPerformance.measureFromMarker(
									'add:wait-for-subscribers',
									startMarker
								);
							});
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										CartPerformance.measure(
											'add:paint-updated-sections',
											() => {
												this.cart.renderContents(response);
											}
										);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							CartPerformance.measure('add:paint-updated-sections', () => {
								this.cart.renderContents(response);
							});
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty'))
							this.cart.classList.remove('is-empty');
						this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner')?.classList.add('hidden');

						CartPerformance.measureFromEvent('add:user-action', evt);
					});
			}

			syncVariantState() {
			const variantSelects = this.querySelector('variant-selects');
			const variantInput = this.selectedVariantInput;
			if (!variantSelects || !variantInput) return null;

			let productData;
			try {
				productData = JSON.parse(variantSelects.dataset.product || '{}');
			} catch (error) {
				productData = {};
			}

			const variants = productData.variants || [];
			let selectedVariant;
			if (variantSelects.dataset.context === 'card') {
				selectedVariant = variants.find(
					(variant) => String(variant.id) === String(variantInput.value)
				);
				if (selectedVariant) {
					this.updateSubmitButtonState(selectedVariant.available === false);
				}
				return selectedVariant || null;
			}

			if (variantSelects.dataset.unified === 'true') {
				const select = variantSelects.querySelector('select');
				const selectedOption = select?.selectedOptions[0];
				const selectedId = select?.value;
				selectedVariant = variants.find((variant) => String(variant.id) === String(selectedId));
				if (selectedId) {
					const value = String(selectedId);
					variantInput.value = value;
					variantInput.setAttribute('value', value);
					this.updateSubmitButtonState(
						selectedVariant?.available === false || selectedOption?.disabled
					);
					return selectedVariant || { id: selectedId };
				}
			} else {
				const selectedOptions = Array.from(
					variantSelects.querySelectorAll('select, fieldset input:checked')
				).map((input) => input.value);
				selectedVariant = variants.find((variant) =>
					variant.options?.length === selectedOptions.length &&
					variant.options.every((option, index) => option === selectedOptions[index])
				);
			}

			if (!selectedVariant?.id) return null;

			const value = String(selectedVariant.id);
			variantInput.value = value;
			variantInput.setAttribute('value', value);
			const selectedInput = variantSelects.querySelector('fieldset input:checked');
			this.updateSubmitButtonState(
				selectedVariant.available === false || selectedInput?.classList.contains('disabled')
			);
			return selectedVariant;
		}

		updateSubmitButtonState(unavailable) {
			if (!this.submitButton) return;

			this.submitButton.disabled = unavailable;
			if (this.submitButtonText) {
				this.submitButtonText.textContent = unavailable
					? window.variantStrings?.soldOut || 'Sold out'
					: this.submitButton.dataset.addToCartText ||
						window.variantStrings?.addToCart ||
						'Add to cart';
			}
		}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						'.product-form__error-message'
					);

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			toggleSubmitButton(disable = true, text) {
				if (disable) {
					this.submitButton.setAttribute('disabled', 'disabled');
					if (text) this.submitButtonText.textContent = text;
				} else {
					this.submitButton.removeAttribute('disabled');
					this.submitButtonText.textContent = window.variantStrings.addToCart;
				}
			}

			get variantIdInput() {
				return this.form.querySelector('[name=id]');
			}
		}
	);
}
